var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { api } from "../client";
export function login(params) {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.post("/api/v1/oauth/token/", __assign(__assign({}, params), { grant_type: "password" }))];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, {
                            createdAt: data.created_at,
                            expiresIn: data.expires_in,
                            token: data.access_token,
                            tokenType: data.token_type,
                        }];
            }
        });
    });
}
export function register(params) {
    return __awaiter(this, void 0, void 0, function () {
        var email, password, source, ref_code, portfolio_id;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    email = params.email, password = params.password, source = params.source, ref_code = params.ref_code, portfolio_id = params.portfolio_id;
                    return [4 /*yield*/, api.post("/api/v1/users/", {
                            user: {
                                email: email,
                                password: password,
                                password_confirmation: password,
                                source: source,
                                ref_code: ref_code,
                                portfolio_id: portfolio_id,
                            },
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/, {
                            success: true,
                        }];
            }
        });
    });
}
export function confirmRegistration(params) {
    return __awaiter(this, void 0, void 0, function () {
        var confirmationToken, email, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    confirmationToken = params.confirmationToken, email = params.email;
                    return [4 /*yield*/, api.get("/api/v1/users/confirmation", {
                            params: {
                                email: email,
                                confirmation_token: confirmationToken,
                            },
                        })];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
}
export function logout(params) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.post("/api/v1/oauth/revoke", __assign(__assign({}, params), { client_id: "uncap", client_secret: "uncap" }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/, {}];
            }
        });
    });
}
export function savePassword(params) {
    return __awaiter(this, void 0, void 0, function () {
        var token, savePasswordParams;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    token = params.token, savePasswordParams = __rest(params, ["token"]);
                    return [4 /*yield*/, api.put("/api/v1/users/invitation/", {
                            user: __assign(__assign({}, savePasswordParams), { invitation_token: token }),
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/, {
                            token: token,
                        }];
            }
        });
    });
}
export function setNewPassword(params) {
    return __awaiter(this, void 0, void 0, function () {
        var token, savePasswordParams;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    token = params.token, savePasswordParams = __rest(params, ["token"]);
                    return [4 /*yield*/, api.put("/api/v1/users/passwords", {
                            user: __assign(__assign({}, savePasswordParams), { reset_password_token: token }),
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/, {
                            token: token,
                        }];
            }
        });
    });
}
export function resetPassword(params) {
    return __awaiter(this, void 0, void 0, function () {
        var resetPasswordParams, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    resetPasswordParams = __rest(params, []);
                    return [4 /*yield*/, api.post("/api/v1/users/passwords", {
                            user: __assign({}, resetPasswordParams),
                        })];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result.data];
            }
        });
    });
}
